jQuery(($) => {
  const pluginName = 'runkeeperPlugin';
  const dataKey = `plugin_${pluginName}`;

  let plugin = null;

  const selectors = {
    profile: '[data-js-runkeeper-profile]',
    connect: '[data-js-runkeeper-connect]',
    disconnect: '[data-js-runkeeper-disconnect]',
  };

  /**
     * Disconnect the profile and prepare the form to re-connect
     */
  const disconnect = () => {
    plugin.element.find(selectors.profile).addClass('hidden');
    plugin.element.find(selectors.connect).removeClass('hidden');
  };

  const Plugin = function runkeeperPlugin(element) {
    plugin = this;
    plugin.element = element;

    // If the profile is not rendered, the user is not connected and we can show the connect button
    if (!plugin.element.find(selectors.profile).length) {
      plugin.element.find(selectors.connect).removeClass('hidden');
    }

    // Bind the disconnect event
    plugin.element.find(selectors.disconnect).on('click', disconnect);
  };

  /**
     * Toggle the display of the integration
     *
     * @param isVisible
     */
  Plugin.prototype.toggle = function toggle(isVisible) {
    plugin.element.toggleClass('hidden', !isVisible);
  };

  /**
     * Is the registrant connected to Runkeeper?
     *
     * @returns {boolean}
     */
  Plugin.prototype.isConnected = function isConnected() {
    return plugin.element.find(selectors.profile).length > 0;
  };

  /**
     * Plugin wrapper, preventing against multiple instantiations and
     * return plugin instance.
     */
  $.fn[pluginName] = function pluginWrapper(options) {
    let thisPlugin = this.data(dataKey);

    // has plugin instantiated ?
    if (thisPlugin instanceof Plugin) {
      // if have options arguments, call plugin.init() again
      if (typeof options !== 'undefined') {
        thisPlugin.init(options);
      }
    } else {
      thisPlugin = new Plugin(this, options);
      this.data(dataKey, thisPlugin);
    }

    return thisPlugin;
  };
});
